import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AccountService } from '@services/account.service';

@Component({
  selector: 'app-info-boxes',
  templateUrl: './info-boxes.component.html',
  styleUrls: ['./info-boxes.component.scss']
})
export class InfoBoxesComponent implements OnInit {

  roomCount: number = 0;

  userCount: number = 0;
  activeUserCount: number = 0;
  expertUserCount: number = 0;
  inRoomUserCount: number = 0;

  sessionCount: number = 0;

  durationHours: number = 0;
  durationMinutes: number = 0;

  accountsMetaSub: Subscription = null;

  constructor(
    private accountService: AccountService
  ) { }

  ngOnInit() {
    this.accountsMetaSub = this.accountService.accountsMeta.subscribe(accountsMeta => {
      this.roomCount = 0;
      this.userCount = 0;
      this.activeUserCount = 0;
      this.expertUserCount = 0;
      this.inRoomUserCount = 0;
      this.sessionCount = 0;
      this.durationHours = 0;
      this.durationMinutes = 0;

      let tempDuration = 0;
      const accountIds = Object.keys(accountsMeta);
      for (const accountId of accountIds) {

        this.roomCount = this.roomCount + (accountsMeta[accountId].rooms ? Object.keys(accountsMeta[accountId].rooms).length : 0);
        this.userCount = this.userCount + (accountsMeta[accountId].users ? Object.keys(accountsMeta[accountId].users).length : 0);
        this.activeUserCount = this.activeUserCount + accountsMeta[accountId].active_users.count;
        this.expertUserCount = this.expertUserCount + (accountsMeta[accountId].active_users.expert_count ? accountsMeta[accountId].active_users.expert_count.count : 0);
        this.inRoomUserCount = this.inRoomUserCount + accountsMeta[accountId].active_users.all_count;
        this.sessionCount = this.sessionCount + (accountsMeta[accountId].total_session_count ? accountsMeta[accountId].total_session_count : 0);
        tempDuration = tempDuration + (accountsMeta[accountId].total_session_duration ? accountsMeta[accountId].total_session_duration : 0);

        this.durationHours = Math.floor(tempDuration / 3600000);
        this.durationMinutes = Math.floor((tempDuration - (this.durationHours * 3600000)) / 60000);
      }
    });
  }

  ngOnDestroy() {
    if (this.accountsMetaSub) { this.accountsMetaSub.unsubscribe() }
  }
}
